export default [{"id":"1","startTime":0,"endTime":3724,"text":"<b>Feel free to browse the following section at your</b>\n<b>leisure.</b>"}];